import gql from 'graphql-tag';

import studySetFields from 'src/graphql/fragments/studySetFields';

export default gql`
  mutation generateQuestionsFromFile(
    $file: UploadInput!
    $studySetId: ID
    $studySetTitle: String
    $studySetDescription: String
  ) {
    generateQuestionsFromFile(
      file: $file
      studySetId: $studySetId
      studySetTitle: $studySetTitle
      studySetDescription: $studySetDescription
    ) {
      ...studySetFields
    }
  }
  ${studySetFields}
`;
